module.exports = __webpack_public_path__ + "img/haekchen-white.51ab18cb.svg";